import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Tooltip, IconButton, Card } from '@material-ui/core'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { COLORES } from '../../../config/colores'

class CpaInfo extends Component {
  constructor (props) {
    super(props)
    this.defaultFields = [
      'ctg', 'camion', 'cereal', 'cerealVariedad', 'exportador',
      'titularDeCupo', 'titular'
    ]
    this.strongFields = ['cereal']
    this.renderField = this.renderField.bind(this)
    this.renderFields = this.renderFields.bind(this)
  }

  renderField ({ field, value, cereal, key }) {
    const style = this.strongFields.includes(field)
      ? 'info-cpa-strong' : null
    return (
      <div key={key} className={`info-cpa-column ${style}-${cereal.toLowerCase()}`}>
        <div className='info-cpa-label'>{_.startCase(field)}</div>
        <div className={`info-cpa-value`}> {/* -${cereal.toLowerCase()} */}
          {value}
        </div>
      </div>
    )
  }

  renderFields (cpa, fields = null) {
    const { openDialogPdf } = this.props
    fields = fields || this.defaultFields
    return (
      <><div className='info-cpa-row'>
        <Tooltip title={'Ver PDF desde ARCA'}>
          <IconButton style={{ padding: '12px', outline: 'none' }} onClick={openDialogPdf}>
            <PictureAsPdfIcon fontSize='large' color='primary' />
          </IconButton>
        </Tooltip>

        {fields.filter(field => cpa[field])
          .map((field, key) => this.renderField({ field, value: cpa[field], cereal: cpa.cereal, key }))}
      </div></>
    )
  }

  render () {
    const {
      cpa,
      cpe
    } = this.props

    return (
      <div className='container-header-proceso-calado'>

        <div className='container-info-cpa d-flex justify-content-between'>
          <div className='d-flex info-cpa'>
            {this.renderFields(cpa)}
          </div>
        </div>

        <div className='container-calle'>
          <Card style={{ backgroundColor: '#ffffff', color: '#495057' }}>
            <div className='calle-calado-en-proceso'>
              <p
                style={{
                  padding: 0,
                  fontSize: '20px',
                  fontWeight: '150',
                  color: '#ffffff',
                  backgroundColor: '#707070'
                }}
              >
                    Calle
              </p>
              <p style={{ fontSize: '2.3rem', padding: 0, color: '#495057', backgroundColor: COLORES.grey.light }}>
                {cpe.calleDeIngreso}
              </p>
            </div>
          </Card>
        </div>
        {/* <div className='container-qr'>
          <QRCode className='qr-code' value={cpa.ctg && cpa.ctg.toString()} size={90} bgColor='#ffffff' fgColor='#000000' level='H' />
        </div> */}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    cpe: state.calado.cpe
  }
}
export default connect(mapStateToProps)(CpaInfo)
